import styled, { css } from "styled-components";
import backGroundImage from './../Login/background.svg';

export const AssociadosVigentesComponent = styled.div.attrs({
	className: ''
})`

		background: url(${backGroundImage});
		background-size: cover;
`;